import { Module } from 'vuex';
import { NodeDomainState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: NodeDomainState = {
    nodeDomains: undefined,
    nodeDomainCount: 0,
    nodeDomainDetails: {
        domain: undefined,
        domainPasswordStrengthSetting: undefined,
    },
    index: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    connectionTest: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

const namespaced: boolean = true;

export const nodeDomain: Module<NodeDomainState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
